<template>
	<div class="amap-page-container" v-show="dt" :style="{height:height}">
		 <el-amap vid="amapDemo" :zoom="zoom1" :center="center" class="amap-demo" :amap-manager="amapManager" :plugin="plugin" :events="events"
		 >
			<el-amap-marker vid="component-marker"></el-amap-marker>
			<el-amap-marker v-for="(marker, index) in markers" :key="index" :position="marker.position" :events="marker.events"
			 :visible="marker.visible" :draggable="marker.draggable" :vid="index" :title="marker.title" :clickable='marker.clickable'
			 :label='marker.label'></el-amap-marker>
			 
			
		</el-amap>

	</div>
</template>

<style>
	.amap-demo {
		height: 300px;
	}
</style>

<script>
	let _this
	export default {
		name: 'amap-page',
		data() {
			return {
				height:"500px",
				dt:false,
				zoom1: 14, //地图缩放比例
				center: [ /* 121.5273285, 31.21515044 */ ], //中心点位置
				markers: [
					/* {
          position: [121.5273285, 31.21515044],
          events: { //标记点事件
            click: () => {
              alert('click marker');
               _this.$router.push({ path:'/home',query:{id:1}  })
            }
          },
          visible: true, //标记点可见
          draggable: false, //设置点标记是否可拖拽移动，默认为false
          title:'这是测试',//鼠标滑过点标记时的文字提示，不设置则鼠标滑过点标无文字提示。
          clickable:true,//点标记是否可点击
          label:{content:'s-12',offset: [10, -22]}
        } */
				],
				 amapManager:'',
				  events: {
					init: (o) => {
					  // console.log(o.getCenter())
					  // console.log(this.$refs.map.$$getInstance())
					  o.getCity(result => {
						console.log(result)
					  })
					},
					'moveend': () => {
					},
					'zoomchange': () => {
					},
					'click': (e) => {
					 
					}
				  },
				  plugin: ['ToolBar', {
					pName: 'MapType',
					defaultType: 0,
					events: {
					  init(o) {
						console.log(o);
					  }
					}
				  }]
			};
		},
		props:['zxd','qt','zoom','h'],
		methods: {
			
				
		},
		mounted() {
			_this = this
			console.log(_this.zoom)
			if(_this.zoom!="" && _this.zoom!=null && _this.zoom!=undefined){
				_this.zoom1=_this.zoom
			}
			console.log(_this.zoom1)
			if(_this.h!="" && _this.h!=null && _this.h!=undefined){
				_this.height=_this.h
			}
			_this.center = _this.zxd
			for (let i = 0; i < _this.qt.length; i++) {
				let b=_this.qt[i]
				let a = {
					position: b.position,//数组：经纬度
					events: { //标记点事件
						click: () => {
							if(b.url!=""){
								_this.$router.push({
									path: b.url,
									query: {
										id: b.id
									}
								})
							}
							
						}
					},
					visible: true, //标记点可见
					draggable: false, //设置点标记是否可拖拽移动，默认为false
					title: b.address, //鼠标滑过点标记时的文字提示，不设置则鼠标滑过点标无文字提示。
					clickable: true, //点标记是否可点击
					label: {
						content: b.code,
						offset: [-10, -22]
					}
				}
			    _this.markers.push(a)
			}
			_this.dt=false
			_this.dt=true

		}
	};
</script>
<style>
	.amap-page-container {
		width: 100%;
	}
	.search-box {
	      position: absolute;
	      top: 50px;
	      left: 80px;
	    }
</style>



// WEBPACK FOOTER //
// src/components/comm/ditu/ditu.vue